import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';

import BootstrapSwitchButton from 'bootstrap-switch-button-react'

import PopupBox from '../PopupBox.js';

import Countdown from '../Countdown.js';

import {Howl, Howler} from 'howler';

const TWEEN = require('@tweenjs/tween.js');

export default class Spin extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            max_attempts: 3,
            currentRotation: 0,
            rotationSpeed: 0,
            rotationAcceleration: 0,
            rotationDrag: 0.98,
            stopTarget: 0,
            num_attempts: 0,
            button0: 1,
            button1: -1,
            box0: false,
            box1: true,
            box0Rotation: 0,
            box1Rotation: 0,
            box0RotationSpeed: 0,
            box1RotationSpeed: 0,
            box0Acceleration: 0,
            box1Acceleration: 0,
            spinNow: false,
            clickSound: new Howl({src: ['./sounds/click.mp3']}),

            box0_size: "small",
            box1_size: "small"

        }
      }
    timer() {
        
           
             //move based on speed/acc
            this.setState({
                rotationSpeed: (this.state.rotationSpeed + this.state.rotationAcceleration) * this.state.rotationDrag,
                box0RotationSpeed: (this.state.box0RotationSpeed + this.state.box0Acceleration) * this.state.rotationDrag,
                box1RotationSpeed: (this.state.box1RotationSpeed + this.state.box1Acceleration) * this.state.rotationDrag,
            })

            this.setState({
                currentRotation: (this.state.currentRotation + this.state.rotationSpeed),
                box0Rotation: (this.state.box0Rotation + this.state.box0RotationSpeed),
                box1Rotation: (this.state.box1Rotation + this.state.box1RotationSpeed),
            })

           
    

        
        
      


        //document.getElementById("spinner").style.transform = "rotate("+this.state.currentRotation+"deg)";

      
        
      }
    componentDidMount() {
        this.intervalId = setInterval(this.timer.bind(this), 25);

        //give more attempts if there's more switches
        if(this.props.num_switches > 1)
        {
          this.setState({max_attempts: 5})
        }
        


      }
    componentWillUnmount(){
        clearInterval(this.intervalId);
      }


    

    render() {


   

    //handle the click on one of the buttons
    const handleClick = (e) => {

      //if the id value of the button and compare to the correct answer

      this.state.clickSound.play()

      let box = parseInt(e.target.getAttribute("box"))

      var currentValue = false;

      let currentValueString = e.target.getAttribute("value")

      if(currentValueString == "true")
      {
        currentValue = true
      }

      console.log("currentValue",currentValue)

      if(box == 0)
      this.setState({
        box0: !currentValue,
        box0_size: "big"
      })

      if(box == 1)
      this.setState({
        box1: !currentValue,
        box1_size: "big"
      })



      setTimeout(() => {
               
        this.setState({
    
          box0_size: "small",
          box1_size: "small"

      })

      }, 100);



    };


    this.rotation = 0;

    


    

    const spinNow = (e) => {


        if(this.props.num_switches == 1)
        {

          if(this.state.num_attempts == 0)
          {
            //always fail first attempt, but fix it so you always get it right next time

            setTimeout(() => {

              
              this.setState({
                box0: true
              })

            }, Math.random()*1000);
        

         

          }

          else
          {

            if(this.state.box0 == false)
            {
                this.props.setResult(true, this)
            }

          }


        }

        else
        {

        

          if(this.state.box0 == false && this.state.box1 == false)
          {
              this.props.setResult(true, this)
          }

        }








     

        if(this.state.num_attempts+1 == this.state.max_attempts)
        {

                    
          this.setState({
            

            num_attempts: this.state.num_attempts + 1,

            })

          this.props.setResult(false, this)

          return

        }


                
        this.setState({
            

          num_attempts: this.state.num_attempts + 1,

            })


        



            this.setState({
          
                
               box0Acceleration: 1.3,

               box1Acceleration: 1.3,
          
                
                rotationAcceleration: 1.3,
    
            })


            setTimeout(() => {
               
                  this.setState({
              
                    rotationAcceleration: 0,

        
                  })

            }, Math.random()*500 + 1000);

            setTimeout(() => {
               
                  this.setState({
              

                    box0Acceleration: 0,

        
                  })

            }, Math.random()*2000 + 500);



            setTimeout(() => {
               
              this.setState({
          

                box1Acceleration: 0,
    
              })

            }, Math.random()*2000 + 500);
    
       
        

           

          
        

        //document.getElementById("spinner").style.transform = "rotate("+this.rotation+"deg)";

      };


      var switches = [  
      
          
          <div className="mycheckbox" id="box0" style={{zIndex: 10}, {transform: "rotate("+this.state.box0Rotation+"deg)"}}>
          <BootstrapSwitchButton
              
              className="switch"
              checked={this.state.box0}
              onlabel='?'
              offlabel='?'
              onstyle="info"
              offstyle="info"
              style="hidden_text"
              onChange={(checked: boolean) => {
                  this.setState({ box0: checked })
              }}
              
          ></BootstrapSwitchButton>
        </div>
        
      ]

      if(this.props.num_switches == 2)
      {

        switches.push(
            <div className="mycheckbox" id="box1" style={{zIndex: 10}, {transform: "rotate("+this.state.box1Rotation+"deg)"}}>
              <BootstrapSwitchButton
                  
                  className="switch"
                  checked={this.state.box1}
                  onlabel='?'
                  offlabel='?'
                  onstyle="info"
                  offstyle="info"
                  style="hidden_text"
                  onChange={(checked: boolean) => {
                      this.setState({ box1: checked })
                  }}
                  
              ></BootstrapSwitchButton>
            </div>

        )


      }

      let num_remaining_attempts = this.state.max_attempts - this.state.num_attempts

      let remaining_attempts = "You have " + num_remaining_attempts + " attempts remaining"; 

    return (

      <PopupBox position={this.props.position} getPos={this.props.getPos} question={this}>


      <Countdown time_allowed={90} getPos={this.props.getPos} question={this} setResult={this.props.setResult}></Countdown>


      <h2 className="text-danger">{this.props.question}</h2>

      <br></br>
      
        <h2 style={{color: "#ce4035"}}>{remaining_attempts}</h2>
     
        <br></br>

        <div id="spinner" class="" style={{transform: "rotate("+this.state.currentRotation+"deg)"}}>

             
            {switches}



        </div>
     

        <div className="d-flex justify-content-center" style={{zIndex: 10000}}>
          <ButtonToolbar>
            <Button onMouseDown={spinNow} className="m-5" variant="danger" size="lg">I'm Feeling Lucky</Button>  
          </ButtonToolbar>

        </div>
        


      </PopupBox>

    );
  }
}
